import React, {useCallback} from 'react';
import TextareaAutosize from 'react-textarea-autosize';


function TextArea({value, autosize, placeholder,
                  disabled,
                  selectOnFocus,
    maxLength,
    onBlur,
    onChange, rows
}: {
    disabled?: boolean,
    onBlur?: ()=>void,
    maxLength?: number,
    selectOnFocus?: boolean,
    rows?: number, value: string, autosize?: boolean, placeholder?: string, onChange?:(text: string)=>void}) {
    const changed = useCallback((e) => {
        if (onChange) {
            onChange(e.target.value);
        }
    }, [onChange]);
    if (autosize) {
     return     <Wrapper value={value} maxLength={maxLength}>
                <TextareaAutosize placeholder={placeholder}
                                 disabled={disabled}
                                 // maxLength={maxLength}
                                 onBlur={onBlur}
                                 onFocus={ selectOnFocus ? (e) => {
                                     e.target.select();
                                 }: undefined}

                                 onChange={changed} value={value}
                                 className={'textarea textarea-bordered w-full'}/>
             </Wrapper>
    }
    return (
       <Wrapper value={value} maxLength={maxLength}>
        <textarea
            onBlur={onBlur}
            // maxLength={maxLength}
            className={"textarea textarea-bordered w-full"}  placeholder={placeholder}
                  rows={rows}
                  onFocus={ selectOnFocus ? (e) => {
                          e.target.select();
                  }: undefined}
                  disabled={disabled}
                  value={value} readOnly={!onChange} onChange={changed}/>
       </Wrapper>
    );
}
function Wrapper({children, maxLength, value}){
    const charsUsed = replaceURLsWithShortUrl(value || '').length;
    return <div className={"relative"}>
        {children}
        {
            maxLength ? <span className={`absolute opacity-75 text-xs  bottom-1 right-2 ${charsUsed > maxLength ? 'text-red-500' : ''}`}>{charsUsed} / {maxLength}</span> : null
        }
    </div>
}

function replaceURLsWithShortUrl(caption: string): string {
    if (!caption) return caption;
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const urls = caption.match(urlRegex);

    if (!urls) return caption;

    for (const url of urls) {
        if(new URL(url).hostname === 'trtl.sh') continue;
        const shortUrl = `https://trtl.sh/abcdef `;
        caption = caption.replace(url, shortUrl);
    }
    return caption;
}


// import TextareaAutosize from 'react-textarea-autosize';
//
//
// function TextArea({value, autosize, placeholder,
//                       disabled,
//                       selectOnFocus,
//                       onChange, rows}: {
//     disabled?: boolean,
//     selectOnFocus?: boolean,
//     rows?: number, value: string, autosize?: boolean, placeholder?: string, onChange?:(text: string)=>void}) {
//     const changed = useCallback((e) => {
//         if (onChange) {
//             onChange(e.target.value);
//         }
//     }, [onChange]);
//     if (autosize) {
//         return <TextareaAutosize placeholder={placeholder}
//                                  disabled={disabled}
//                                  onFocus={ selectOnFocus ? (e) => {
//                                      e.target.select();
//                                  }: undefined}
//
//                                  onChange={changed} value={value}
//                                  className={'form-control'}/>;
//     }
//     return (
//         <textarea placeholder={placeholder}
//                   rows={rows}
//                   onFocus={ selectOnFocus ? (e) => {
//                           e.target.select();
//                   }: undefined}
//                   disabled={disabled}
//                   className={'form-control'} value={value} readOnly={!onChange} onChange={changed}/>
//     );
// }

export default TextArea;
